import React from 'react'
import * as S from '../styled'
import { SearchClubData } from '../types'
import SearchEvaluationItem from './SearchEvaluation'
import { navigate } from '@app/navigation'

interface ClubItemProps {
  club: SearchClubData
  isExpanded: boolean
  onToggle: (clubName: string) => void
  onEvaluationClick: (evaluationId: string) => void
  onMarkAsDemo: (evaluationId: string, currentlyDemo: boolean) => void
  onMarkAsActive: (evaluationId: string, clubId: string) => void
  isAdminUser: boolean
}

const SearchClubItem = React.memo<ClubItemProps>(
  ({
    club,
    isExpanded,
    onToggle,
    onEvaluationClick,
    onMarkAsDemo,
    onMarkAsActive,
    isAdminUser,
  }) => {
    const allEvaluations = club.evaluations

    const handleGoToClub = async () => {
      navigate('ClubManagementStack', {
        screen: 'ClubManagement',
        wait: true,
        params: {
          club: club.club,
        },
      })

      /*
           *
           * Navigates to manage ratings, but does not work currently
           * 
           
          const holeIds = evaluation.holeIds.join(',')
    
          const templateBody = {
            courseId: evaluation.courseId,
            clubId: club.clubId,
            name: evaluation.courseName,
            holeIds,
            defaultCourseSettings: {
              bunkDepthDefault: 0,
              grassType: 'cool',
              intermediateCut: 0,
              measurement: 'imperial',
              roughHeight: 3,
              stimpFeet: 9,
              stimpInches: 0,
              'wind_1-9': 0,
              'wind_10-18': 0,
            },
            mapped: true,
          }
    
          let templateId: string
          try {
            const { data } = await axios.get<RatingTemplate>(
              `/templates?holeIds=${holeIds}`
            )
            templateId = data.id
          } catch (error) {
            const { data } = await axios.post<RatingTemplate>(
              '/templates',
              templateBody
            )
            templateId = data.id
          }
          navigate('CreateRating', {
            holeIds,
            templateId,
            club,
            branchId: evaluation.branchId,
            isRateable: true,
          })

          /*


          navigate('ClubManagementStack', {
            screen: 'CreateRating',
            wait: false,
            params: {
              evaluation.holeIds,
              templateId,
              club,
              branchId: data?.projectBranchID,
              isRateable: true,
            },
          })
          *
    */
    }

    return (
      <S.StyledClubItem>
        <S.ClubHeader
          onClick={() => club.clubId && onToggle(club.clubId)}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onToggle(club.clubName)
            }
          }}
        >
          <S.ClubHeaderMain>
            <S.ExpandIcon expanded={isExpanded}>
              {isExpanded ? '▼' : '►'}
            </S.ExpandIcon>
            <S.ClubName>{club.clubName}</S.ClubName>
            <S.CourseCount>
              {allEvaluations.length} rating
              {allEvaluations.length !== 1 ? 's' : ''}
            </S.CourseCount>
            <S.PrimaryButton
              style={{
                backgroundColor: '#4190e0',
                marginLeft: 'auto',
              }}
              onClick={() => handleGoToClub()}
            >
              Manage club
            </S.PrimaryButton>
          </S.ClubHeaderMain>
          {(club.districtCountry ||
            club.districtName ||
            club.districtRegionName ||
            club.branchStatus) && (
            <S.ClubHeaderInfo>
              {club.districtCountry && (
                <S.ClubInfoBadge>
                  <strong>Country:</strong> {club.districtCountry}
                </S.ClubInfoBadge>
              )}
              {club.districtName && (
                <S.ClubInfoBadge>
                  <strong>District:</strong> {club.districtName}
                </S.ClubInfoBadge>
              )}
              {club.districtRegionName && (
                <S.ClubInfoBadge>
                  <strong>Region:</strong> {club.districtRegionName}
                </S.ClubInfoBadge>
              )}
            </S.ClubHeaderInfo>
          )}
        </S.ClubHeader>

        {isExpanded && (
          <S.EvaluationList>
            {allEvaluations.map((evaluation) => (
              <SearchEvaluationItem
                key={evaluation.id}
                club={club}
                evaluation={evaluation}
                onEvaluationClick={onEvaluationClick}
                onMarkAsDemo={onMarkAsDemo}
                onMarkAsActive={onMarkAsActive}
                isAdminUser={isAdminUser}
              />
            ))}
          </S.EvaluationList>
        )}
      </S.StyledClubItem>
    )
  }
)

export default SearchClubItem
